import React, {useEffect, useRef} from 'react';
import {FormattedMessage} from 'react-intl';
import NoResults from '../searchable_dropdown/NoResults';
import _ from 'lodash';
import Highlight from 'react-highlighter';
import {t} from 'shared/core';

const SearchableDropdownSelectOptions = ({
                                           sections = [],
                                           options = [],
                                           query = '',
                                           selectedIndex = -1,
                                           onSelect
                                         }) => {
  const handleItemClick = (item) => {
    if (onSelect) {
      onSelect(item);
    }
  };

  const optionsRefs = useRef([]);

  useEffect(() => {
    let allOptions;
    if (!_.isEmpty(options)) {
      allOptions = options;
    } else {
      allOptions = _.flatMap(sections, sections => sections.options.toJS ? sections.options.toJS() : sections.options);
    }

    optionsRefs.current = optionsRefs.current.slice(0, allOptions.length);
  }, [sections]);

  useEffect(() => {
    if (selectedIndex === -1 || !optionsRefs.current[selectedIndex]) return;

    optionsRefs.current[selectedIndex].scrollIntoViewIfNeeded();
  }, [selectedIndex]);

  let globalIndex = 0;

  if (!_.isEmpty(sections)) {
    return (
      sections.map((section) => (
          <div key={section.name}>
            <div className='border-bottom'>
              <div className='searchable-dropdown-select-section'>
                {section.alreadyTranslated ? section.name : <FormattedMessage id={section.name}/>}
              </div>
            </div>
            <div>
              {section.options.map(item => {
                const currentIndex = globalIndex++;
                const isSelected = currentIndex === selectedIndex;
                return (
                  <div key={item.key || item.name} ref={element => optionsRefs.current[currentIndex] = element} onClick={() => handleItemClick(item)}>
                    <div className={`searchable-dropdown-select-item ${isSelected ? 'selected' : ''}`}>
                      <Highlight search={query}>
                        {item.alreadyTranslated ? item.name : t(item.name)}
                      </Highlight>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )
      )
    );
  }

  if (_.isEmpty(sections) && !_.isEmpty(options)) {
    return (
      options.map(item => {
        const currentIndex = globalIndex++;
        const isSelected = currentIndex === selectedIndex;
        return (
          <div key={item.key || item.name} ref={element => optionsRefs.current[currentIndex] = element} onClick={() => handleItemClick(item)}>
            <div className={`searchable-dropdown-select-item ${isSelected ? 'selected' : ''}`}>
              <Highlight search={query}>
                {item.alreadyTranslated ? item.name : t(item.name)}
              </Highlight>
            </div>
          </div>
        );
      })
    );
  }

  return (
    <NoResults query={query}/>
  );
};

export default SearchableDropdownSelectOptions;
